module.exports = __webpack_public_path__ + "img/09.92c34817.png";